/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Rename_ButtonInputs */



/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Explorer_Info_Rename_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_rename_button = /** @type {((inputs?: Explorer_Info_Rename_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Rename_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Renommer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Umbenennen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rinominare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переименовать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rebautizar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重命名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("名前を変更")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नाम बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Renomear")
	return /** @type {LocalizedString} */ ("Rename")
});